import { useEffect, useState } from "react";
import { Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";

// Pops up once each time the currency switches to USD in the New Price form.
export function UsdBaseQtyHint({ currency }) {
  const [open, setOpen] = useState(false);
  useEffect(() => { if (currency === "USD") setOpen(true); }, [currency]);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-md" data-testid="usd-baseqty-hint-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Info size={18} className="text-cyan-700" />USD price — use Base qty</DialogTitle>
          <DialogDescription>
            USD prices are usually tiny per piece. Enter the price for a bigger quantity and put that quantity in <b>Base qty</b>.
          </DialogDescription>
        </DialogHeader>
        <div className="rounded-sm border border-cyan-200 bg-cyan-50 px-3 py-2 text-sm text-cyan-900">
          <b>Base qty 100 = 6.5 USD</b> means <b>0.065 USD/EA</b>.<br />
          Unit must be <b>EA</b> — XPA / packet is not allowed.
        </div>
        <DialogFooter>
          <Button onClick={() => setOpen(false)} data-testid="usd-baseqty-hint-ok">Got it</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
